export default __webpack_public_path__ + "static/media/FreshAirSummaryIcon.2e818164.svg";